import { DataLayer } from 'features/systemLens'
import {
  AlertTriangle,
  Layers,
  Settings,
  TrendingUp,
  Waypoints,
} from 'lucide-react'

export const DEFAULT_DATA_LAYERS: DataLayer[] = [
  {
    id: 'process-data',
    name: 'Process Data',
    type: 'sensor',
    icon: <TrendingUp size={16} />,
    enabled: true,
    color: '#00c290',
  },
  {
    id: 'anomalies',
    name: 'Anomaly Detection',
    type: 'anomaly',
    icon: <AlertTriangle size={16} />,
    enabled: false,
    color: '#f87171',
  },
  {
    id: 'events',
    name: 'Operational Events',
    type: 'event',
    icon: <Settings size={16} />,
    enabled: false,
    color: '#fbbf24',
  },
  {
    id: 'thresholds',
    name: 'Alert Thresholds',
    type: 'threshold',
    icon: <Layers size={16} />,
    enabled: false,
    color: '#60a5fa',
  },
  {
    id: 'sentinels',
    name: 'Sentinels',
    type: 'sentinel',
    icon: <Waypoints size={16} />,
    enabled: false,
    color: '#a78bfa',
  },
]
